var map = {
	"./dashboard.svg": 9037,
	"./example.svg": 3862,
	"./eye-open.svg": 2540,
	"./eye.svg": 4082,
	"./form.svg": 1551,
	"./link.svg": 6229,
	"./nested.svg": 8588,
	"./password.svg": 1681,
	"./table.svg": 6758,
	"./tree.svg": 4998,
	"./user.svg": 2383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;